// extracted by mini-css-extract-plugin
export default {"page-background":"BmZ5pC","pageBackground":"BmZ5pC"};